import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { TechnicianServiceType } from 'types';

type getTechnicianServiceTypesParams = {
  technicianId?: string;
};

export const getTechnicianServiceTypes = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianServiceTypesParams]>): Promise<TechnicianServiceType[]> => {
  const [, params] = queryKey;
  const { data } = await baseQuery(`technicians/${params.technicianId}/service-types`);

  return data as TechnicianServiceType[];
};
